// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"a3b45417","100":"cddeb067","182":"c2fd16cf","312":"dddf0de2","320":"a91f8a90","453":"bfae4969","457":"bf90caa9","604":"8272cfa5","616":"3f6b82e0","849":"40323643","875":"364426ba","950":"67b8ca89"}[chunkId] + ".chunk.js";
};